import { render, staticRenderFns } from "./ModalSubmitConfirm.vue?vue&type=template&id=6df8f742&scoped=true&"
import script from "./ModalSubmitConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalSubmitConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubmitConfirm.vue?vue&type=style&index=0&id=6df8f742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df8f742",
  null
  
)

export default component.exports